<div class="home-container">
    <mat-card class="chart-container transport-chart-container">
        <mat-card-title>
            {{ 'dashboard.transport' | translate }}
        </mat-card-title>
        <mat-card-content style="padding: 50px;">
            <app-transport-chart></app-transport-chart>
        </mat-card-content>
        <mat-card-actions style="display: flex;
        justify-content: flex-end;">
            <button mat-raised-button color="primary" (click)="onNewTonnage()">{{ 'button.new-tonnage' | translate
                }}</button>
            <button mat-raised-button color="primary" (click)="onNewToll()">{{ 'button.new-toll' | translate }}</button>
        </mat-card-actions>
    </mat-card>

    <mat-card class="chart-container material-chart-container ">
        <mat-card-title>
            {{ 'dashboard.materials' | translate }}
        </mat-card-title>
        <mat-card-content style="padding: 50px;">
            <app-material-chart></app-material-chart>
        </mat-card-content>
    </mat-card>

    <!-- <mat-card class="chart-container dangerous-material-chart-container ">
        <mat-card-title>
            {{ 'dashboard.dangerous-transport' | translate }}
        </mat-card-title>
        <mat-card-content style="padding: 50px;">
            <app-dangerous-material></app-dangerous-material>
        </mat-card-content>
    </mat-card> -->

    <mat-card class="chart-container material-chart-container" *ngIf="uiService.visibleByRole([Role.user])">
        <mat-card-title>
            {{ 'dashboard.contract' | translate }}
        </mat-card-title>
        <mat-card-content style="padding: 20px;height: calc(100% - 70px);overflow-y: auto;">
            <app-contract-chart></app-contract-chart>
        </mat-card-content>
    </mat-card>
</div>